/*
 * AINAKWEAR Product Rails V13
 * One owner for Similar Products + You Might Also Like.
 * Transform animation avoids native scroll-snap frame loss on iOS/WebKit.
 */
(function () {
  'use strict';

  if (window.__EW_PRODUCT_SYSTEM_LOADER_V13__) return;
  window.__EW_PRODUCT_SYSTEM_LOADER_V13__ = true;

  var ROOT_SELECTOR = '[data-ew-related-v9],[data-ew-yml-v9]';
  var VIEWPORT_SELECTOR = '[data-ew-pdp-rail-viewport]';
  var ITEM_SELECTOR = '[data-ew-pdp-rail-item]';
  var controllers = new WeakMap();

  function number(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function nearestIndex(values, target) {
    var best = 0;
    var distance = Infinity;
    values.forEach(function (value, index) {
      var nextDistance = Math.abs(value - target);
      if (nextDistance < distance) {
        distance = nextDistance;
        best = index;
      }
    });
    return best;
  }

  function createController(root) {
    if (!root || controllers.has(root)) return controllers.get(root);

    var viewport = root.querySelector(VIEWPORT_SELECTOR);
    var track = viewport && viewport.firstElementChild;
    var items = track ? Array.prototype.slice.call(track.querySelectorAll(ITEM_SELECTOR)) : [];
    if (!viewport || !track || items.length < 2) return null;

    var duration = Math.max(520, Math.min(900, number(root.dataset.duration, 760)));
    var delay = 2000;
    var autoplay = root.dataset.autoplay !== 'false';
    var easing = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
    var positions = [0];
    var index = 0;
    var direction = 1;
    var timer = 0;
    var settleTimer = 0;
    var moving = false;
    var dragging = false;
    var dragId = null;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragDelta = 0;
    var dragHorizontal = false;
    var suppressClick = false;
    var destroyed = false;
    var resizeObserver;
    var lastViewportWidth = viewport.clientWidth;

    viewport.style.setProperty('overflow-x', 'clip', 'important');
    viewport.style.setProperty('scroll-snap-type', 'none', 'important');
    viewport.style.setProperty('scroll-behavior', 'auto', 'important');
    viewport.style.touchAction = 'pan-y';
    viewport.style.cursor = 'grab';
    viewport.scrollLeft = 0;
    track.style.willChange = 'transform';
    track.style.transform = 'translate3d(0,0,0)';
    track.style.transitionProperty = 'transform';
    track.style.transitionTimingFunction = easing;
    track.style.transitionDuration = duration + 'ms';
    items.forEach(function (item) { item.style.scrollSnapAlign = 'none'; });

    function clearTimers() {
      window.clearTimeout(timer);
      window.clearTimeout(settleTimer);
      timer = 0;
      settleTimer = 0;
    }

    function canRun() {
      return !destroyed && autoplay && !document.hidden && !dragging && positions.length > 1;
    }

    function setTransform(offset, animate) {
      track.style.transitionDuration = animate ? duration + 'ms' : '0ms';
      track.style.transform = 'translate3d(' + (-Math.max(0, offset)) + 'px,0,0)';
    }

    function schedule(wait) {
      window.clearTimeout(timer);
      timer = 0;
      if (!canRun()) return;
      timer = window.setTimeout(step, typeof wait === 'number' ? wait : delay);
    }

    function settle() {
      if (!moving) return;
      moving = false;
      window.clearTimeout(settleTimer);
      settleTimer = 0;
      schedule(Math.max(160, delay - duration));
    }

    function goTo(nextIndex, animate, userDirection) {
      if (!positions.length) return;
      index = Math.max(0, Math.min(positions.length - 1, nextIndex));
      if (userDirection) direction = userDirection;
      window.clearTimeout(settleTimer);
      moving = Boolean(animate);
      setTransform(positions[index], animate);
      if (animate) settleTimer = window.setTimeout(settle, duration + 90);
      else moving = false;
    }

    function step() {
      timer = 0;
      if (!canRun() || moving) return;
      if (index >= positions.length - 1) direction = -1;
      if (index <= 0) direction = 1;
      goTo(index + direction, true, direction);
    }

    function recompute() {
      if (destroyed) return;
      items = Array.prototype.slice.call(track.querySelectorAll(ITEM_SELECTOR));
      var first = items[0];
      var maximum = Math.max(0, track.scrollWidth - viewport.clientWidth);
      var next = [];
      if (first) {
        items.forEach(function (item) {
          var value = Math.max(0, Math.min(maximum, item.offsetLeft - first.offsetLeft));
          if (!next.length || Math.abs(value - next[next.length - 1]) > 1) next.push(value);
        });
      }
      if (maximum > 1 && (!next.length || Math.abs(maximum - next[next.length - 1]) > 1)) next.push(maximum);
      if (!next.length) next = [0];
      var oldOffset = positions[index] || 0;
      positions = next;
      index = nearestIndex(positions, oldOffset);
      if (index >= positions.length - 1) direction = -1;
      if (index <= 0) direction = 1;
      goTo(index, false);
      if (!timer && !moving) schedule(delay);
    }

    function pause() {
      clearTimers();
      moving = false;
      var matrix = window.getComputedStyle(track).transform;
      if (matrix && matrix !== 'none') {
        var match = matrix.match(/^matrix(?:3d)?\((.+)\)$/);
        if (match) {
          var values = match[1].split(',').map(parseFloat);
          var x = values.length === 16 ? values[12] : values[4];
          if (Number.isFinite(x)) {
            track.style.transitionDuration = '0ms';
            track.style.transform = 'translate3d(' + x + 'px,0,0)';
            index = nearestIndex(positions, Math.abs(x));
          }
        }
      }
    }

    function resume() {
      goTo(index, false);
      schedule(delay);
    }

    function onPointerDown(event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pause();
      dragging = true;
      dragId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragDelta = 0;
      dragHorizontal = false;
      suppressClick = false;
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== dragId) return;
      var dx = event.clientX - dragStartX;
      var dy = event.clientY - dragStartY;
      var wasHorizontal = dragHorizontal;
      if (!dragHorizontal && Math.abs(dx) > 7) dragHorizontal = Math.abs(dx) > Math.abs(dy);
      if (!dragHorizontal) return;
      if (!wasHorizontal) {
        viewport.style.cursor = 'grabbing';
        if (viewport.setPointerCapture) viewport.setPointerCapture(dragId);
      }
      event.preventDefault();
      dragDelta = dx;
      suppressClick = Math.abs(dx) > 10;
      var base = positions[index] || 0;
      var candidate = Math.max(0, Math.min(positions[positions.length - 1] || 0, base - dx));
      setTransform(candidate, false);
    }

    function onPointerEnd(event) {
      if (!dragging || event.pointerId !== dragId) return;
      dragging = false;
      viewport.style.cursor = 'grab';
      if (viewport.releasePointerCapture && viewport.hasPointerCapture && viewport.hasPointerCapture(dragId)) {
        viewport.releasePointerCapture(dragId);
      }
      var threshold = Math.min(70, viewport.clientWidth * 0.12);
      var next = index;
      if (dragHorizontal && Math.abs(dragDelta) >= threshold) next += dragDelta < 0 ? 1 : -1;
      else if (dragHorizontal) next = nearestIndex(positions, (positions[index] || 0) - dragDelta);
      next = Math.max(0, Math.min(positions.length - 1, next));
      goTo(next, true, dragDelta < 0 ? 1 : dragDelta > 0 ? -1 : direction);
      dragId = null;
      dragDelta = 0;
    }

    function onClick(event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }

    function onKeyDown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      pause();
      var delta = event.key === 'ArrowRight' ? 1 : -1;
      goTo(index + delta, true, delta);
    }

    function onTransitionEnd(event) {
      if (event.target === track && event.propertyName === 'transform') settle();
    }

    function onViewportScroll() {
      if (Math.abs(viewport.scrollLeft) > 0.5) viewport.scrollLeft = 0;
    }

    function onVisibilityChange() {
      if (document.hidden) pause();
      else resume();
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', onPointerEnd);
    viewport.addEventListener('pointercancel', onPointerEnd);
    viewport.addEventListener('keydown', onKeyDown);
    viewport.addEventListener('click', onClick, true);
    viewport.addEventListener('scroll', onViewportScroll, { passive: true });
    track.addEventListener('transitionend', onTransitionEnd);
    document.addEventListener('visibilitychange', onVisibilityChange);

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function (entries) {
        var nextWidth = entries[0] && entries[0].contentRect ? entries[0].contentRect.width : viewport.clientWidth;
        if (Math.abs(nextWidth - lastViewportWidth) < 1) return;
        lastViewportWidth = nextWidth;
        window.requestAnimationFrame(recompute);
      });
      resizeObserver.observe(viewport);
    }

    recompute();

    var controller = {
      destroy: function () {
        destroyed = true;
        clearTimers();
        if (resizeObserver) resizeObserver.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        viewport.removeEventListener('scroll', onViewportScroll);
        controllers.delete(root);
      },
      refresh: recompute
    };
    controllers.set(root, controller);
    return controller;
  }

  function init(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches(ROOT_SELECTOR)) createController(base);
    Array.prototype.forEach.call(base.querySelectorAll(ROOT_SELECTOR), createController);
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? event.target
      : event.target && event.target.querySelector && event.target.querySelector(ROOT_SELECTOR);
    var controller = root && controllers.get(root);
    if (controller) controller.destroy();
  });
})();
